export const FREE_TRIAL_PAGE_VIEWED = 'Free Trial - Page Viewed';
export const FREE_TRIAL_ACTIVATE = 'Free Trial - Activate Free Trial Clicked';
export const FREE_TRIAL_GOAL_SELECTED = 'Free Trial - Goal Selected';
export const FREE_TRIAL_GOAL_SELECTION_CONFIRMED =
  'Free Trial - Goal Selection Confirmed';
export const FREE_TRIAL_GOAL_SELECTION_CONFIRMATION_CLOSED =
  'Free Trial - Goal Confirmation Modal Closed';
export const FREE_TRIAL_ACTIVATED = 'Free Trial - Free Trial Activated';
export const FREE_TRIAL_DOWNLOAD_APP_CLICKED = 'Download App Clicked';
export const FREE_TRIAL_GOAL_DROPDOWN_CLICKED =
  'Free Trial - Goal Dropdown Clicked';
export const FREE_TRIAL_REFERRAL_AAPLIED = 'Free Trial - Referral Code Applied';
export const FREE_TRIAL_GO_TO_HOME_CLICKED = 'Free trial - Go To Home Clicked';
